import clsx from 'clsx'
import React from 'react'
import style from './Switch.module.sass'

type SwitchProps = {
	name?: string
	disabled?: boolean
	checked?: boolean
	value: string
	label: string
	onChange: (checked: boolean, value: string) => void
}

export const Switch = React.memo(function Switch(props: SwitchProps) {
	return (
		<label className={clsx(style.wrapper, props.disabled && style.wrapperDisabled)}>
			<div className={style.switch}>
				<input
					name={props.name}
					type="checkbox"
					checked={props.checked}
					disabled={props.disabled}
					onChange={(e) => {
						const checked = e.currentTarget.checked
						props.onChange(checked, props.value)
					}}
					className={clsx(style.input, props.checked && style.inputChecked)}
				/>

				<span className={clsx(style.slider, style.round)} />
			</div>
			<span className={clsx(style.label, props.disabled && style.labelDisabled)}>{props.label}</span>
		</label>
	)
})
